var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOrganizationIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3861 0.400024C17.2232 0.400024 19.5984 2.84497 19.5984 5.9371C19.5984 10.5394 16.4974 15.0697 10.4933 19.4562C10.3613 19.5281 10.2294 19.6 10.0314 19.6C9.89947 19.6 9.76751 19.5281 9.63555 19.4562H9.56957C3.49947 15.0697 0.398438 10.5394 0.398438 5.9371C0.398438 2.84497 2.70772 0.400024 5.61081 0.400024C6.79844 0.400024 7.85411 0.831485 8.77782 1.55059C9.10772 1.83823 9.1737 2.41351 8.90978 2.77306C8.64586 3.13261 8.11803 3.20452 7.78813 2.91688C7.19431 2.41351 6.40256 2.12587 5.61081 2.12587C3.63143 2.12587 2.04792 3.85171 2.04792 5.9371C2.04792 9.74834 4.62112 13.6315 9.96545 17.6585L10.0314 17.7304L10.0974 17.6585C15.3758 13.7034 17.949 9.82025 18.0149 6.08092V5.9371C18.0149 3.85171 16.4314 2.12587 14.452 2.12587C12.9345 2.12587 11.549 3.13261 11.0871 4.64272C10.9551 5.07418 10.4933 5.36182 10.0314 5.14609C9.63555 5.00227 9.37163 4.4989 9.56957 3.99553C10.2294 1.91014 12.2087 0.400024 14.3861 0.400024Z",
    fill: "#CA1D3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrganizationIcon2);
export default __webpack_public_path__ + "static/media/noOrganizationIcon2.ca86d8bc0dd2e89def16e2e20724c72e.svg";
export { ForwardRef as ReactComponent };